<script>
import { getBuyerCampaigns } from '@/graphql/campaign/queries.graphql';

import { QueryHelper } from '@/components/Core/Helpers';

export default {
  mixins: [QueryHelper],
  props: {
    pager: {
      type: Object,
      default: () => {}
    }
  },

  query(props) {
    return {
      query: getBuyerCampaigns,
      variables: {
        buyer_id: this.$store.getters['auth/buyerId'],
        ...props.pager
      }
    };
  }
};
</script>
